import { render, staticRenderFns } from "./FissionTablePane.vue?vue&type=template&id=5bd8e2da&scoped=true"
import script from "./FissionTablePane.vue?vue&type=script&lang=js"
export * from "./FissionTablePane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8e2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd8e2da')) {
      api.createRecord('5bd8e2da', component.options)
    } else {
      api.reload('5bd8e2da', component.options)
    }
    module.hot.accept("./FissionTablePane.vue?vue&type=template&id=5bd8e2da&scoped=true", function () {
      api.rerender('5bd8e2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/fission/components/FissionTablePane.vue"
export default component.exports